import React, { useEffect, useState } from 'react';
import { Breadcrumb, BreadcrumbItem, Form, FormGroup, Label, Input, Row, Col, Button } from 'reactstrap';
import { Colxx, Separator } from '../../../components/common/CustomBootstrap';
import axios from 'axios'
import {appScreen, baseUrl, defaultScreens, imageAcceptFormat} from '../../../constants/defaultValues';
import { createNotification } from '../../../helpers/Notification';
import { useStoreActions } from "easy-peasy";
import DatePicker from "react-datepicker";
import moment from 'moment-timezone';
import Api from '../../../helpers/Api';


const ApiReq = new Api()

let forEdit = false
const ModalCreate = (props) => {

  const {  checkError } = useStoreActions(action => ({
    checkError: action.checkError,
  }))

  ApiReq.checkError = checkError

  const options = ['',
  {
    name:'Speakers',
    type: 'speakers'
  },
  {
    name: 'Regular users',
    type: 'users'
  },
  {
    name: 'All users',
    type: 'all'
  }]


  const [state, setState] = useState({
    id: '',
    imageUrl: '',
    originalImageUrl: '',
    path: '',
    type: '',
    screen: null,
    name: '',
    podcastId: '',
    buttonTitle: '',
    usersType: '',
    // expiryDate: ''
  })

  Date.prototype.addDays = function(days) {
    let date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
  }
  const [isUploading, setUploading] = useState(false)
  const [thumbItem, setThumbItem] = useState(null)

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date().addDays(1))

  useEffect(() => {
    if (props.match.params.id) {
      forEdit = true
      handleEditData()
    } else {
      forEdit = false
    }
  }, [])

  const handleEditData = () => {
    getThumbnail(props.match.params.id)
  }

  const getThumbnail = (id) => {
    axios.get(`${baseUrl}/modals/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem("token") || ''
      }
    }).then(res => {
      const item = res?.data?.d
      if (item) {
        setThumbItem(item)
        const ind = item.stack.length > 1 ? 1 : 0
        const idPodcast = item.stack.length > 1 ? item?.stack[0]?.params?.id : null
        const newItem = {
          id: item?.stack[ind]?.params?.id,
          imageUrl: item?.originalImageUrl,
          originalImageUrl: item?.originalImageUrl,
          path: item?.stack[ind]?.path,
          type: item?.type,
          screen: item?.stack[ind]?.path,
          name: item?.name,
          podcastId: idPodcast,
          buttonTitle: item.buttonTitle,
          usersType: item.usersType,
          // expiryDate: new Date(item.expiryDate)
        }
        setStartDate(new Date(item?.startDate))
        setEndDate(new Date(item?.endDate))
        setState(newItem)
      }
    }).catch(err => {

    })
  }

  const updateState = (prop, value) => {
    setState({
      ...state,
      [prop]: value,
    })
  }

  const valueChangeHandler = (e) => {
    const { name, value } = e.target
    updateState(name, value)
  }


  const onSelectScreen =  (el) => {
    const i = el.target.value
    const item = defaultScreens[i]
    setState({
      ...state,
      path: item?.link,
      type: item?.type,
      name: item?.name,
      podcastId: '',
      id: '',
    })
  }

  const onSelectAppScreen = (el) => {
    const i = el.target.value
    const item = appScreen[i]
    setState({
      ...state,
      path: '',
      screen: item?.link,
      name: item?.name,
      podcastId: '',
      id: '',
    })
  }

  const onSelectTypeUsers = (el) => {
    const i = el.target.value
    const item = options[i]

    setState({
      ...state,
      usersType: item.type || '',
    })
  }

  const onSelectExpiryDate = (el) => {
    setState({
      ...state,
      expiryDate: el || '',
    })
  }

  const onFileSelectHandler = (e) => {
    let files = e.target.files
    let reader = new FileReader()
    reader.readAsDataURL(files[0])
    const formData = new FormData()

    reader.onload = (e) => {
      formData.append('photo', files[0])
      uploadPhoto(files[0])
    }
  }

  const uploadPhoto = (file) => {
    setUploading(true)
    let formData = new FormData()
    formData.append('photo', file)

    axios.post(`${baseUrl}/media/photos`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': localStorage.getItem('token')
      }
    }).then(res => {

      let imageUrl = res.data.d.thumbnailUrl
      let originalImageUrl = res.data.d.photoUrl
      setState({
        ...state,
        imageUrl,
        originalImageUrl
      })
      setUploading(false)

    }).catch(err => {
      console.log(err)
      createNotification('waning', 'Failed to upload image')
      updateState('imageUrl', '')
    })
  }

  const createCollectionFunc = () => {
    const { id, imageUrl, originalImageUrl, buttonTitle, usersType, expiryDate } = state

    if (!originalImageUrl || originalImageUrl === '') {
      createNotification('warning', 'Upload an Image')
      return
    }

    const objReq = thumbItem?.stack[0] || { params: {} }

    const obj = objReq

    obj.path = state?.path ? state?.path : state?.screen

    if (id) {
      obj.params.id = id ? id.trim() : ''
    }
    if (state?.name && state.name !== objReq?.name) {
      obj.params.name = state?.name
    }

    const zone = "America/New_York";

    let data = {
      type: state?.type,
      stack: [obj],
      imageUrl: originalImageUrl,
      originalImageUrl: originalImageUrl,
      buttonTitle,
      usersType,
      // expiryDate: format(expiryDate),
      startDate: moment.tz(startDate, zone),
      endDate: moment.tz(endDate, zone)
    }

    if (state?.podcastId) {
      data.stack[0].params.name = 'Episode'
      data.stack.unshift(
        {
          path: 'Podcasts',
          params: {
            name: 'Podcast',
            id: state.podcastId,
          }
        }
      )
    }

    if (forEdit) {
      data.id = thumbItem._id
      ApiReq.editModal({ data, history: props.history, id: thumbItem?._id })
    } else {
      ApiReq.createModal({ data, history: props.history })
    }
  }

  const resetFile = () => {
    document.getElementById("file").value = "";
    updateState('originalImageUrl', null)
  }

  const { imageUrl, id, buttonTitle, originalImageUrl } = state
  var date = new Date()
  let minDate = date

  return (
    <div style={{ height: '800px' }}>
      <Row>
        <Colxx xxs='12'>
          <Breadcrumb>
            <BreadcrumbItem>Modals</BreadcrumbItem>
            <BreadcrumbItem active>{forEdit ? `Edit` : `Create`}</BreadcrumbItem>
          </Breadcrumb>
          <Separator />
        </Colxx>
      </Row>
      <div className={'thumbnail-create'}>
        <div className={'thumb-part'}>
          <FormGroup>
            <Label>Picture</Label>
            <Input id={'file'} type="file" name="file" onChange={onFileSelectHandler} accept={imageAcceptFormat} />
            {isUploading ? <span>Uploading...</span> : null}
            <br></br>
            {
              originalImageUrl
                ?
                <>
                  <img alt="Profile" src={originalImageUrl} width="300px" />
                </>
                :
                null
            }
          </FormGroup>
          {originalImageUrl ? <Button onClick={resetFile} color="secondary">Delete</Button> : null}
        </div>
        <Separator />

        <div className={'thumb-part'}>
          <Form>
            <FormGroup>
              <Label for="body">Screens: </Label>
              <Input type="select" name="otherId" id="exampleSelect" onChange={onSelectScreen}>
                {defaultScreens.map((item, index) => {
                  return <option
                    selected={item?.type === state?.type}
                    key={index}
                    value={index}>{item.name}</option>
                })}
              </Input>
            </FormGroup>

            {state && state.hasOwnProperty('type') && state?.type ?
              state?.type !== 'screen' ?
              <>
                {state?.type === 'podcast' ?
                  <FormGroup>
                    <Label>Podcast Id</Label>
                    <Input type="text" name="podcastId" value={state?.podcastId} onChange={valueChangeHandler} />
                  </FormGroup>
                : null}
                <FormGroup>
                  <Label>{defaultScreens.find(i => i.type === state?.type)?.name} {state?.type !== 'externalLink' ? 'Id' : ''}</Label>
                  <Input type="text" name="id" value={id} onChange={valueChangeHandler} />
                </FormGroup>
              </>
              : <>
                <Label for="body">Application screens: </Label>
                <Input type="select" name="otherId" id="exampleSelect" onChange={onSelectAppScreen}>
                  {appScreen.map((item, index) => {
                    return <option
                      selected={item.link === state?.screen}
                      key={index}
                      value={index}>{item.name}</option>
                  })}
                </Input>
              </>
              : null
            }
            <FormGroup>
              <Label for="body">Type of users: </Label>
              <Input type="select" name="otherId" id="exampleSelect" onChange={onSelectTypeUsers}>
                  {options.map((item, index) => {
                      return <option
                          selected={state.usersType === item.type}
                          key={item?._id}
                          value={index}>{item.name}</option>
                  })}
              </Input>
          </FormGroup>
          <FormGroup>
          <Label for="body">Start Date: </Label>
          <DatePicker
              selected={startDate}
              onChange={(date) => {
                setStartDate(date)
                if (date.getTime() > endDate.getTime()) {
                  setEndDate(date)
                }
              }}
              dateFormat="MM/dd/yyyy h:mm aa"
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={60}
              timeCaption="Time"
              className='calendar-modal'
              wrapperClassName='calendar-modal'
              // isClearable={forEdit}
              minDate={minDate}
            />
          </FormGroup>
          <FormGroup>
          <Label for="body">End Date: </Label>
            <DatePicker
              className='calendar-modal'
              wrapperClassName='calendar-modal'
              minDate={startDate}
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              dateFormat="MM/dd/yyyy h:mm aa"
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={60}
              timeCaption="Time"
              // isClearable={forEdit}
            />
          </FormGroup>
          <FormGroup>
              <Label>Button</Label>
              <Input placeholder='OK' type="text" name="buttonTitle" value={buttonTitle} onChange={valueChangeHandler} />
            </FormGroup>
            <Button onClick={createCollectionFunc} color="primary">{forEdit ? `Save` : `Send`}</Button>
          </Form>
        </div>

      </div>
    </div>
  );

}

export default ModalCreate;